//Assets andd Miscellaneous
import { XIcon } from "@heroicons/react/solid";
import styles from "./badge.module.css";

//Component Begin
export default function Badge({
  badgeType,
  text,
  status,
  handleRemove,
}: {
  badgeType?: string;
  text: string;
  status?: string;
  handleRemove?: () => void;
}) {
  return (
    <span
      className={`capitalize flex items-center gap-2 ${
        !badgeType && !styles["fallBack"]
      } ${badgeType && styles[badgeType]} ${status && styles[status]}`}
    >
      {text}
      {handleRemove && (
        <XIcon
          className="h-4 w-4 hover:text-tertiaryColor-normal cursor-pointer"
          onClick={handleRemove}
        />
      )}
    </span>
  );
}
